<template>
    <sidebar :title="selectedRetailer.retailerID != null
        ? `Edit Master Dealer ${selectedRetailer.name}`
        : 'Add Master Dealer '
        " :show="showRetailerSidebar" @on-close="close" size="sm">
        <template v-slot:body>
            <form @submit.prevent="submitRetailer" ref="retailerForm">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Type of Dealer</label>
                            <div class="mb-3">
                                <select class="form-select" v-model="selectedRetailer.dealerType" required>
                                    <option>Corporate</option>
                                    <option>Cooperative</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- hidden column-->
                    <div class="col d-none">
                        <div class="form-group">
                            <label>Type of Transcation</label>
                            <div class="mb-3">
                                <select class="form-select" v-model="selectedRetailer.transactionType">
                                    <option>SMART</option>
                                    <option>BAYAD</option>
                                    <option>BOTH</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Business Name</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.name"
                                    :disabled="submitting" required />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Name of Representative</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.representative"
                                    :disabled="submitting" required />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Contact Number</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.contactNumber"
                                    :disabled="submitting" required />
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Email Address</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.email"
                                    :disabled="submitting" required />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="form-group">
                        <label>Company Address</label>
                        <div class="mb-3">
                            <input type="text" class="form-control" v-model="selectedRetailer.companyAddress"
                                :disabled="submitting" required />
                        </div>
                    </div>
                </div>

                <div class="row" v-if="selectedRetailer.transactionType !== 'BAYAD'">
                    <div class="col">
                        <div class="form-group">
                            <label>Corporate ID</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.corporateID"
                                    :disabled="submitting" required />
                            </div>
                        </div>
                    </div>
                    <!-- hidden column-->
                    <div class="col d-none">
                        <div class="form-group">
                            <label>Branch ID</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.branchID"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- hidden column-->
                <div class="row d-none" v-if="selectedRetailer.transactionType !== 'BAYAD'">
                    <div class="col">
                        <div class="form-group">
                            <label>Username</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.userName"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Password</label>
                            <div class="mb-3">
                                <input type="password" class="form-control" v-model="selectedRetailer.password"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- hidden column-->
                <div class="row d-none" v-if="selectedRetailer.transactionType !== 'BAYAD'">
                    <div class="col">
                        <div class="form-group">
                            <label>Secret Key</label>
                            <div class="mb-3">
                                <input type="password" class="form-control" v-model="selectedRetailer.secretKey"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Terminal ID</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.terminalID"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- hidden column-->
                <div class="row d-none" v-if="selectedRetailer.transactionType !== 'BAYAD'">
                    <div class="col-9">
                        <div class="form-group">
                            <label>Address</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.address"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Zip Code</label>
                            <div class="mb-3">
                                <input type="text" class="form-control" v-model="selectedRetailer.zipCode"
                                    :disabled="submitting" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <button type="submit" class="btn bg-info bg-violet text-white w-100 mt-4 mb-0"
                        :disabled="submitting" @click="submitRetailer">

                        <div class="spinner-border spinner-border-sm" role="status" v-if="submitting">
                            <span class="sr-only">Loading...</span>
                        </div>
                        Submit
                    </button>
                </div>
            </form>
        </template>
    </sidebar>
    <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
        @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import GlobalModal from "@/components/GlobalModal.vue";

export default {
    data() {
        return {
            modal: { show: false, type: 'success', title: '', message: '' }
        };
    },
    components: {
        sidebar,
        GlobalModal
    },
    computed: {
        ...mapState({
            submitting: (state) => state.retailerController.submitting,
            showRetailerSidebar: (state) =>
                state.retailerController.showRetailerSidebar,
            selectedRetailer: (state) => state.retailerController.selectedRetailer,
        }),
    },
    methods: {
        ...mapActions({
            getRetailers: "retailerController/GetRetailers",
            addRetailer: "retailerController/AddRetailer",
            updateRetailer: "retailerController/UpdateRetailer",
        }),
        ...mapMutations({
            toggleShowRetailerSidebar:
                "retailerController/TOGGLE_ShowRetailerSidebar",
            ResetRetailer: "retailerController/SELECT_Retailer",
        }),
        close() {
            this.toggleShowRetailerSidebar(false);
            this.ResetRetailer({});
        },
        async submitRetailer() {
            const form = this.$refs.retailerForm;

            if (!form.checkValidity()) {
                form.reportValidity(); // Shows the built-in browser messages
                return;
            }
            if (this.selectedRetailer.retailerID != null) {
                var result = await this.updateRetailer().catch((error) => {
                    console.log(error);
                });

                if (result) {

                    this.showModal(
                        'success',
                        `Retailer ${this.selectedRetailer.name} successfully updated.`,
                    );
                    this.close();
                    await this.getRetailers();
                }
            } else {
                var result = await this.addRetailer().catch((error) => {
                    console.log(error);
                });

                if (result) {
                    this.close();
                    this.showModal(
                        'success',
                        `Retailer successfully added.`,
                    );
                    await this.getRetailers();
                }
            }
        },
        showModal(type, title, message) {
            return new Promise((resolve) => {
                this.modal = {
                    show: true,
                    type,
                    title,
                    message,
                    onConfirm: () => {
                        this.modal.show = false;
                        resolve(true);
                    },
                    onCancel: () => {
                        this.modal.show = false;
                        resolve(false);
                    },
                };
            });
        }
    },
};
</script>

<style></style>
